import queryString from 'qs';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getSurvey, updateSurvey } from '../../reducers/survey';
import SurveySuccess from './SurveySuccess';

import SurveyForm from './SurveyForm';
import Spinner from '../Spinner';

export const Header = () => (
    <header className="header-hub">
        <div className="container">
            <Link to="/" className="logo" title="Vivriti Capital Market Place">
                Vivriti Capital
            </Link>
        </div>
    </header>
);

class Survey extends React.PureComponent {
    componentDidMount() {
        const { getSurveyInfo, surveyId, userId } = this.props;
        if (surveyId && userId) {
            getSurveyInfo(surveyId, userId);
        }
    }

    handleSurvey = (surveyId, values, userId) => {
        const { submitSurvey } = this.props;
        return submitSurvey(surveyId, values, userId);
    };

    render() {
        const { survey, surveyId, userId } = this.props;
        let comp;
        if (survey) {
            if (survey.message) {
                comp = <SurveySuccess message={survey.message} />;
            } else {
                comp = (
                    <div>
                        <Header />
                        {survey ? <SurveyForm initialValues={survey} onSubmit={(v) => this.handleSurvey(surveyId, v, userId)} /> : <Spinner />}
                    </div>
                );
            }
        } else {
            comp = <Spinner />;
        }
        return comp;
    }
}

const mapStateToProps = (state, props) => {
    const {
        match: {
            params: { surveyId },
        },
        location,
    } = props;
    const qs = location && location.search && queryString.parse(location.search, { ignoreQueryPrefix: true });
    return {
        survey: surveyId && state.survey && state.survey[surveyId],
        surveyId,
        userId: qs.user_id,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getSurveyInfo: (surveyId, userId) => dispatch(getSurvey(surveyId, userId)),
    submitSurvey: (surveyId, data, userId) => dispatch(updateSurvey(surveyId, data, userId)),
});

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);

Survey.propTypes = {
    surveyId: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    submitSurvey: PropTypes.func.isRequired,
    getSurveyInfo: PropTypes.func.isRequired,
};

export default reduxConnector(Survey);
